import { CustomerAddressType } from '../enums';

export class EditCustomerAddressInput {
    public id: number = 0;
    public districtId: number = 0;
    public postalCode: string = '';
    public description: string = '';
    public customerId: number = 0;
    public customerAddressType: CustomerAddressType = CustomerAddressType.BillingAddress;
}
